module.exports = __webpack_public_path__ + "img/Firma_Barragan.ab05aa93.png";